<template>
	<div class="landing-home" v-if="pageHome.elements">
		<!-- content home -->
		<hero :props="pageHome.elements"  :heroHome="true"></hero>

		<!-- CX2 -->
		<section id="section" class="section-block cx2 container-fluid col-xs-12" v-in-viewport="">
			<div class="inner">
				<h2 class="text-center" v-in-viewport="">
					Too is better than one.
				</h2>

				<!--
				<div class="logo text-center" v-in-viewport="">
					<img src="/dist/cx2.png" />
				</div>
				-->
				<div class="row">
					<div class="col-lg-8 col-lg-offset-2 fade-in" v-in-viewport="">
						<p class="text-center">Great digital solutions require a combination of strategic thinking, technical skill, UX and analytics prowess to derive and optimize value from the customer journey.</p>
						<p class="text-center">Marcus Thomas’ digital team adds one more important thing to the mix: we deliver digital solutions that consider your company’s journey, too.</p>
					</div>
				</div>

				<button @click="openJourney()" tag="button" class="btn_orange gtm_buttonCX2_learnmore_topCTA">DOWNLOAD OUR POV</button>
			</div>
		</section>



		<!-- YOUR JOURNEY -->
		<section id="your-journey" class="section-block  your-journey container-fluid col-xs-12" v-in-viewport="">
			<div class="inner">
				<h2 class="text-center" v-in-viewport="">
					Your journey is about to begin …
				</h2>
				<div class="row">
					<div class="col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 ">
						<p class="text-small">* Required fields.</p>
					</div>

					<div class="col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 not-gutter">
						<form id="journeyForm" @submit.prevent="validateForm('journeyForm')" data-vv-scope="journeyForm" action='https://crm.zoho.com/crm/WebToLeadForm' name=WebToLeads3285587000000368027 method='POST' accept-charset='UTF-8'  >

							<!-- Do not remove this code. -->
							<input type=hidden name='captcha_settings' value='{"keyname":"Captcha","fallback":"true","orgId":"00D6A0000038T85","ts":""}'>
							<input type=hidden name="oid" value="00D6A0000038T85">
							<input type=hidden name="retURL" value="http://">
							<input type=hidden name="Campaign_ID" value="7013u0000007r6zAAA">
							<input type=hidden name="lead_source" value="Website">
							<!-- Do not remove this code. -->

							<div class="form-row">
								<div class="form-group col-md-6" :class="{error:errors.has('journeyForm.first_name')}">
									<span class="required" v-if="journeyForm.first_name === ''">*</span>
									<input type="text" class="form-control" id="first_name" maxlength='40' name='first_name' placeholder="First Name" v-validate="'required'" v-model="journeyForm.first_name">
									<span class="message-error" v-show="errors.has('journeyForm.first_name')" >{{ errors.first('journeyForm.first_name') }}</span>
								</div>
								<div class="form-group col-md-6" :class="{error:errors.has('contactForm.last_name')}">
									<span class="required" v-if="journeyForm.last_name === ''">*</span>
									<input type="text" class="form-control"  id="last_name" maxlength='80' name='last_name' placeholder="Last Name" v-validate="'required'" v-model="journeyForm.last_name">
									<span class="message-error" v-show="errors.has('journeyForm.last_name')" >{{ errors.first('journeyForm.last_name') }}</span>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-md-6" :class="{error:errors.has('journeyForm.company')}">
									<span class="required" v-if="journeyForm.company === ''">*</span>
									<input type="text" class="form-control" id="company" maxlength='100' name='company' placeholder="Company" v-validate="'required'" v-model="journeyForm.company">
									<span class="message-error" v-show="errors.has('journeyForm.company')" >{{ errors.first('journeyForm.company') }}</span>
								</div>
								<div class="form-group col-md-6" :class="{error:errors.has('journeyForm.email')}">
									<span class="required" v-if="journeyForm.email === ''">*</span>
									<input type="email" class="form-control" id="email" maxlength='100' name='email' placeholder="Email" v-validate="'required|email'" v-model="journeyForm.email">
									<span class="message-error" v-show="errors.has('journeyForm.email')" >{{ errors.first('journeyForm.email') }}</span>
								</div>
							</div>

							<div class="clearfix"></div>

							<vue-recaptcha @verify="markRecaptchaAsVerifiedJourney" class="captcha" sitekey="6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"></vue-recaptcha>

							<div class="captcha-error">
								<p class="text-small">{{ journeyForm.pleaseTickRecaptchaMessage }}</p>
							</div>

							<div class="form-row">
						    <div class="text-center">
						      <button type="submit" tag="button" class="btn_orange gtm_buttonCX2_whitepaper_download">Download Whitepaper</button>
						    </div>
						  </div>

						</form>
					</div>

					<div class="col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 subscribe">
						<p class="text-small">By providing us with your information, you may receive occasional updates about Marcus Thomas products and services, as well as invitations to exclusive webinars and events. You can unsubscribe from emails at any time. See our <a href="/privacy" class="" target="_blank">Privacy Policy.</a></p>
					</div>
				</div>
			</div>
		</section>

		<!-- PERFORMACE -->
		<section id="performance" class="section-block performance container-fluid col-xs-12" v-in-viewport="">
			<div class="inner">
				<h2 class="text-center" v-in-viewport="">
					Performance and predictability, too.
				</h2>

				<div class="row">
					<div class="col-lg-8 col-lg-offset-2">
						<p class="text-center" v-in-viewport="">Proven discovery and definition processes, and best-in-class collaboration and communications tools, ensure development strategy and UX are informed by client and user needs and technology – and that key solutions are tested in the hypothetical stage.</p>
					</div>
				</div>

				<div class="row icons">
					<div class="col-xs-6 col-sm-3 col-lg-2 col-lg-offset-2">
						<div class="inner-icons">
							<div class="icon-container" v-in-viewport="">
								<img src="/dist/agile.svg" />
							</div>
							<div class="label"><span>Agile Planning / Roadmapping</span></div>
						</div>
					</div>
					<div class="col-xs-6 col-sm-3 col-lg-2">
						<div class="inner-icons">
							<div class="icon-container" v-in-viewport="">
								<img src="/dist/detail.svg" />
							</div>
							<div class="label"><span>Detailed Documentation</span></div>
						</div>
					</div>
					<div class="col-xs-6 col-sm-3 col-lg-2">
						<div class="inner-icons">
							<div class="inner-icons">
								<div class="icon-container" v-in-viewport="">
									<img src="/dist/ux-test.svg" />
								</div>
								<div class="label"><span>UX Testing</span></div>
							</div>
						</div>
					</div>
					<div class="col-xs-6 col-sm-3 col-lg-2">
						<div class="inner-icons">
							<div class="icon-container" v-in-viewport="">
								<img src="/dist/collab.svg" />
							</div>
							<div class="label"><span>Collaboration & Communication</span></div>
						</div>
					</div>
				</div>


				<!-- PARTNERS -->
				<div class="row">
					<div class="col-lg-8 col-lg-offset-2">
						<div class="partners-container" v-in-viewport="">
								<img src="/dist/mural.png" />
								<img src="/dist/sketch.png" />
								<img src="/dist/invision.png" />
								<img src="/dist/optimal.png" />
								<img src="/dist/jira.png" />
						</div>
					</div>
				</div>


				<button  tag="button" class="btn_orange gtm_buttonCX2_letstalk" v-scroll-to="'#contact-form'">let's talk</button>
			</div>
		</section>

		<!-- BIG IDEAS -->
		<section id="big-ideas" class="section-block big-ideas container-fluid col-xs-12" v-in-viewport="">
			<div class="inner">
				<h2 class="text-center" v-in-viewport="">
					Shouldn’t you expect big execution, too?
				</h2>

				<div class="row">
					<div class="col-lg-8 col-lg-offset-2">
						<p class="text-center">Big ideas drive innovation and are essential to engaging customers. Big ideas need big execution, too. That’s why our team is organized and focused on the four areas innovative companies need most:</p>
					</div>
				</div>


				<div class="row icons">
					<div class="col-sm-3 col-lg-2 col-lg-offset-2">
						<div class="inner-icons">
							<div class="icon-container" v-in-viewport="">
								<img src="/dist/ux-design.svg" />
							</div>
							<div class="label"><span>User Experience Design</span></div>
							<div class="toggle-icon"><span><img src="/dist/plus.svg" /></span></div>
							<div class="info">
								<ul>
									<li>Customer journey map development</li>
									<li>Experience maps</li>
									<li>Low- and high-fidelity wireframing</li>
									<li>Static and functional prototyping</li>
									<li>Live and web-based UX testing</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-sm-3 col-lg-2">
						<div class="inner-icons">
							<div class="icon-container" v-in-viewport="">
								<img src="/dist/web-mobile-dev.svg" />
							</div>
							<div class="label"><span>Enterprise Web & Mobile Development</span></div>
							<div class="toggle-icon"><span><img src="/dist/plus.svg" /></span></div>
							<div class="info">
								<ul>
									<li>Web and mobile site development</li>
									<li>Custom web and mobile apps</li>
									<li>CMS and eCommerce implementation</li>
									<li>Promotion/content updates, maintenance</li>
									<li>Outsourcing, staff augmentation and managed services</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-sm-3 col-lg-2">
						<div class="inner-icons">
							<div class="icon-container" v-in-viewport="">
								<img src="/dist/crm-market.svg" />
							</div>
							<div class="label"><span>CRM / Marketing Automation</span></div>
							<div class="toggle-icon"><span><img src="/dist/plus.svg" /></span></div>
							<div class="info">
								<ul>
									<li>Salesforce Marketing Cloud consulting and implementation</li>
									<li>Salesforce Sales and Service Cloud integrations</li>
									<li>Third-party CRM integrations (MS Dynamics, Sugar CRM)</li>
									<li>Custom Salesforce Marketing Cloud apps</li>
									<li>Custom Salesforce Journey Builder activities</li>
								</ul>
							</div>
						</div>
					</div>
					<div class="col-sm-3 col-lg-2">
						<div class="inner-icons">
							<div class="icon-container" v-in-viewport="">
								<img src="/dist/analytics.svg" />
							</div>
							<div class="label"><span>Analytics & Performance Optimization</span></div>
							<div class="toggle-icon"><span><img src="/dist/plus.svg" /></span></div>
							<div class="info">
								<ul>
									<li>Measurement strategy design</li>
									<li>Website tracking implementation</li>
									<li>End-to-end campaign measurement and reporting</li>
									<li>Cross-channel and multi-touch attribution</li>
									<li>Custom dashboard development in Tableau and Data Studio</li>
								</ul>
							</div>
						</div>
					</div>
				</div>

				<!-- PARTNERS -->
				<div class="row">
					<div class="col-lg-8 col-lg-offset-2">
						<div class="partners-container">
								<img src="/dist/kentico.png" />
								<img src="/dist/sitecore.png" />
								<img src="/dist/sitefinity.png" />
								<img src="/dist/salesforce.png" />
								<img src="/dist/google-cloud.png" />
						</div>
					</div>
				</div>

				<button  tag="button" class="btn_orange gtm_buttonCX2_tellusaboutyourjourney"  v-scroll-to="'#contact-form'">tell us about your journey</button>

			</div>
		</section>

		<!-- BETTER THAN ONE -->
		<section id="better-than-one" class="section-block better-than-one container-fluid col-xs-12" v-in-viewport="">
			<div class="inner">
				<h2 class="text-center" v-in-viewport="">
					Isn’t it time you got to know us?
				</h2>

				<div class="row">
					<div class="col-lg-8 col-lg-offset-2">
						<p class="text-center text-bold">700+ Websites and Mobile Apps  |  50+ Salesforce  Marketing Cloud Implementations  | 72 Experts</p>
						<p class="text-center">For more than 20 years, global brands and B2B leaders have called on us to develop and implement digital strategies, launch online ventures, and create or improve their digital marketing initiatives.</p>
					</div>
				</div>

				<!-- PARTNERS -->
				<div class="row">
					<div class="col-lg-8 col-lg-offset-2">
						<div class="partners-container m25">
								<img src="/dist/troy-bilt.png" />
								<img src="/dist/fanatics.png" />
								<img src="/dist/ibm.png" />
								<img src="/dist/key-bank.png" />
								<img src="/dist/cu.png" />
								<img src="/dist/momentive.png" />
								<img src="/dist/oh-lottery.png" />
								<img src="/dist/maritz.png" />
								<img src="/dist/assurant.png" />
								<img src="/dist/firstenergy.png" />
						</div>
					</div>
				</div>

			</div>
		</section>

		<!-- CX2 -->
		<section id="contact-form" class="section-block contact-form container-fluid col-xs-12" v-in-viewport="">
			<div class="inner">
				<h2 class="text-center" v-in-viewport="">
					Contact Us
				</h2>
				<div class="row">

					<div class="col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 ">
						<p class="text-small">* Required fields.</p>
					</div>

					<div class="col-md-8 col-lg-6 col-md-offset-2 col-lg-offset-3 not-gutter">
						<form id="contactForm" @submit.prevent="validateForm('contactForm')" data-vv-scope="contactForm" action='https://crm.zoho.com/crm/WebToLeadForm' name=WebToLeads3285587000000345044 method='POST' accept-charset='UTF-8'  >
							<!-- Do not remove this code. -->
							<!-- <input type='text' style='display:none;' name='xnQsjsdp' value='f1c7c74f09065682e1d56ffe4c97645d08387b1b7086f4c6bb7118de4ad08959'/>
							<input type='hidden' name='zc_gad' id='zc_gad' value=''/>
							<input type='text' style='display:none;' name='xmIwtLD' value='4b98f2a03b7fb9570df3cb9573aed15de667c68fe354d55c2eaea21a740d85ee'/>
							<input type='text' style='display:none;'  name='actionType' value='TGVhZHM='/>
							<input type='text' style='display:none;' name='returnURL' value='http://newwebsite.mt.stage.mtllc.com/thank-you' />
							<input type='hidden' name='LEADCF3' id='LEADCF3' value='Campaign name' v-model="contactForm.campaign" data-vv-scope="contactForm"/>
							<input type='hidden' name='LEADCF1' id='LEADCF1' value='My Journey Landing Page'/>
							-->
							<input type=hidden name='captcha_settings' value='{"keyname":"Captcha","fallback":"true","orgId":"00D6A0000038T85","ts":""}'>
							<input type=hidden name="oid" value="00D6A0000038T85">
							<input type=hidden name="retURL" value="http://">
							<input type=hidden name="Campaign_ID" value="7013u000000FBMSAA4">
							<input type=hidden name="lead_source" value="Website">
							<!-- Do not remove this code. -->

							<div class="form-row">
								<div class="form-group col-md-6" :class="{error:errors.has('contactForm.first_name')}">
									<span class="required" v-if="contactForm.first_name === ''">*</span>
									<input type="text" class="form-control" id="first_name" maxlength='40' name='first_name' placeholder="First Name" v-validate="'required'" v-model="contactForm.first_name">
									<span class="message-error" v-show="errors.has('contactForm.First Name')" >{{ errors.first('contactForm.first_name') }}</span>
								</div>
								<div class="form-group col-md-6" :class="{error:errors.has('contactForm.last_name')}">
									<span class="required" v-if="contactForm.last_name === ''">*</span>
									<input type="text" class="form-control"  id="last_name" maxlength='80' name='last_name' placeholder="Last Name" v-validate="'required'" v-model="contactForm.last_name">
									<span class="message-error" v-show="errors.has('contactForm.Last Name')" >{{ errors.first('contactForm.last_name') }}</span>
								</div>
							</div>

							<div class="form-row">
								<div class="form-group col-md-6" :class="{error:errors.has('contactForm.company')}">
									<span class="required" v-if="contactForm.company === ''">*</span>
									<input type="text" class="form-control" id="company" maxlength='100' name='company' placeholder="Company" v-validate="'required'" v-model="contactForm.company">
									<span class="message-error" v-show="errors.has('contactForm.company')" >{{ errors.first('contactForm.company') }}</span>
								</div>
								<div class="form-group col-md-6" :class="{error:errors.has('contactForm.email')}">
									<span class="required" v-if="contactForm.email === ''">*</span>
									<input type="email" class="form-control" id="email" maxlength='100' name='email' placeholder="Email" v-validate="'required|email'" v-model="contactForm.email">
									<span class="message-error" v-show="errors.has('contactForm.email')" >{{ errors.first('contactForm.email') }}</span>
								</div>
							</div>

							<div class="clearfix"></div>

						  <div class="form-row">
								<div class="form-group checkbox-container col-xs-12">
							    <div class="form-check">
							      <input class="form-check-input" type="checkbox" id="check_1" name="check_1"  value="1" v-model="contactForm.check_1">
							      <label class="form-check-label" for="check_1">
							        I have an upcoming need I’d like to discuss.
							      </label>
							    </div>
									<div class="form-check">
							      <input class="form-check-input" type="checkbox" id="check_2" name="check_2"  value="1" v-model="contactForm.check_2">
							      <label class="form-check-label" for="check_2">
							        I’d like to schedule a capabilities presentation.
							      </label>
							    </div>
									<div class="form-check">
							      <input class="form-check-input" type="checkbox" id="check_3" name="check_3"  value="1" v-model="contactForm.check_3">
							      <label class="form-check-label" for="check_3">
							        Other
							      </label>
							    </div>
									<span v-if="!contactForm.checkBoxSelected"class="checkbox-message-error">Select at least one option</span>
								</div>
						  </div>

							<div class="form-row">
						    <div class="form-group col-md-12">
						      <textarea id="description" rows="8" cols="80" class="track-it" placeholder="Let’s talk about your journey …" name='description' maxlength='32000' v-model="contactForm.description"></textarea>
						    </div>
						  </div>

							<vue-recaptcha @verify="markRecaptchaAsVerifiedContact" class="captcha" sitekey="6LfWNoYsAAAAAPb_D9jpoKajSmdXs6WDQx98RUXd"></vue-recaptcha>

							<div class="captcha-error">
								<p class="text-small">{{ contactForm.pleaseTickRecaptchaMessage }}</p>
							</div>


							<div class="form-row">
						    <div class="form-group text-center col-xs-12">
						      <button type="submit" tag="button" class="btn_orange gtm_buttonCX2_contactformsubmit">Submit</button>
						    </div>
						  </div>


							<div v-if="contactForm.formSubmitted" :class="[contactForm.formSubmitted ? 'thank-message fadeIn' : '']">
								<div class="row" v-in-viewport="">
									<div class="col-lg-8 col-lg-offset-2">
										<p class="text-center">Ok, you’ve taken the first step. We’ll get back to you within one business day.</p>
									</div>
								</div>
							</div>

						</form>
					</div>
				</div>


			</div>
		</section>

	</div>
</template>



<script>
	import seoModule from '../mixins/seoModule.js';
	import VueRecaptcha from 'vue-recaptcha';
	import hero from '../components/hero.vue';
	import FileSaver from 'file-saver/FileSaver';

	//require('	data/home.json');
	require('../assets/img/hero.png');
	require('../assets/img/hero-mobile.png');
	require('../assets/img/cx2.png');

	//Svg Icons
	require('../assets/img/agile.svg');
	require('../assets/img/collab.svg');
	require('../assets/img/detail.svg');
	require('../assets/img/ux-test.svg');
	require('../assets/img/analytics.svg');
	require('../assets/img/crm-market.svg');
	require('../assets/img/web-mobile-dev.svg');
	require('../assets/img/ux-design.svg');
	require('../assets/img/plus.svg');



	//Partners
	require('../assets/img/partners/mural.png');
	require('../assets/img/partners/sketch.png');
	require('../assets/img/partners/invision.png');
	require('../assets/img/partners/optimal.png');
	require('../assets/img/partners/jira.png');


	require('../assets/img/partners/kentico.png');
	require('../assets/img/partners/sitecore.png');
	require('../assets/img/partners/sitefinity.png');
	require('../assets/img/partners/salesforce.png');
	require('../assets/img/partners/google-cloud.png');

	require('../assets/img/partners/troy-bilt.png');
	require('../assets/img/partners/fanatics.png');
	require('../assets/img/partners/ibm.png');
	require('../assets/img/partners/key-bank.png');
	require('../assets/img/partners/cu.png');

	require('../assets/img/partners/momentive.png');
	require('../assets/img/partners/oh-lottery.png');
	require('../assets/img/partners/maritz.png');
	require('../assets/img/partners/assurant.png');
	require('../assets/img/partners/firstenergy.png');

	export default{
		name:'Home',
		data () {
		   return {
		   	 pageHome: [],
		     works: [],
		     words:[],
		     modularContent:[],
				 contactForm: {
						 recaptchaVerified: false,
						 pleaseTickRecaptchaMessage: '',
						 oid:'00D6A0000038T85',
						 first_name:'',
						 last_name:'',
						 company: '',
						 email: '',
						 description: '',
						 campaign: '7013u000000FBMSAA4',
						 lead_source: 'Website',
						 retURL: 'https://mtllc.com/thank-you',
						 formSubmitted: false,
						 check_1: '',
						 check_2: '',
						 check_3: '',
						 checkBoxSelected : true
			   },
				 journeyForm: {
			      recaptchaVerified: false,
	          pleaseTickRecaptchaMessage: '',
	          oid:'00D6A0000038T85',
	          first_name:'',
	          last_name:'',
	          company: '',
	          email: '',
	          campaign: '7013u0000007r6zAAA',
	          lead_source: 'Website',
	          retURL: 'https://mtllc.com/thank-you',
	          formSubmitted: false,
			   }
		   }
		 },
		created:function(){
			this.loadCX2Data();
		},
		mounted: function() {

			if (typeof this.$route.query.utm_campaign !== 'undefined' && this.$route.query.utm_campaign !== ''){
				this.contactForm.campaign = this.$route.query.utm_campaign;
				this.journeyForm.campaign = this.$route.query.utm_campaign;
			}

			setTimeout(function(){

			    	$('.toggle-icon').on('click' ,function () {
			    		var text = $(this).siblings('.info').children('ul');

			    		if (text.is(':hidden')) {
			    			text.slideDown('200');
			    			$(this).children('span').addClass('opened');
			    		} else {
			    			text.slideUp('200');
			    			$(this).children('span').removeClass('opened');
			    		}

			    	});

						$('.inner-icons .label span').on('click' ,function () {

			    		var text = $(this).closest('.inner-icons').find('.info').children('ul');

			    		if (text.is(':hidden')) {
			    			text.slideDown('200');
			    			$(this).closest('.inner-icons').find('.toggle-icon > span').addClass('opened');
			    		} else {
			    			text.slideUp('200');
			    			$(this).closest('.inner-icons').find('.toggle-icon > span').removeClass('opened');
			    		}

			    	});

						//Journey GTM Events
						$('form#journeyForm .form-control').each(function(){
							$(this).focus(function(e){
									var n = $(this).attr('name');
									dataLayer.push({'event': 'Whitepaper Form', 'fieldname': n });
							});
						});

						//Contact GTM Events
						$('form#contactForm .form-control').each(function(){
							$(this).focus(function(e){
									var n = $(this).attr('name');
									dataLayer.push({'event': 'Contact Us Form', 'fieldname': n });
							});
						});
						$('form#contactForm .form-check-input').each(function(){
							$(this).focus(function(e){
									var n = $(this).next('label').text();
									dataLayer.push({'event': 'Contact Us Form', 'checkbox': n });

							});
						});
						$('form#contactForm textarea.track-it').focus(function(e){
								var n = $(this).attr('name');
								dataLayer.push({'event': 'Contact Us Form', 'fieldname': n });
						});


			},500);
		},
		methods: {
			loadCX2Data() {
				this.$http.get("/src/data_jsons/cx_2.json").then((response) => {
					this.pageHome = response.body.items[0];
					this.modularContent = response.body.modular_content;
					
					// Show footer after loading data
					setTimeout(function () {
						$("#footer").show();
					}, 500);
				});
			},
			webToLead(fields,scope) {
				var customHiddenIframeName='JLA_API';
				if(!document.getElementById(customHiddenIframeName)){
					var theiFrame=document.createElement("iframe");
					theiFrame.id=customHiddenIframeName;
					theiFrame.name=customHiddenIframeName;
					theiFrame.src='about:blank';
					theiFrame.style.display='none';
					document.body.appendChild(theiFrame);
				}
				fields['retURL']='http://127.0.0.1';//dummy URL
				var form = document.createElement("form");
				form.method = "POST";
				form.action = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
				form.setAttribute("target", customHiddenIframeName);
				for (var fieldName in fields) {
					var theInput = document.createElement("input");
					theInput.name=fieldName;
					theInput.value=fields[fieldName];
					theInput.setAttribute("type", "hidden");
					form.appendChild(theInput);
				}
				document.body.appendChild(form);
				form.submit();
				this.contactForm.formSubmitted=true;
				let _this = this;

				if(scope=='journeyForm'){
						this.$http.get('/CX2-client.pdf',{responseType: 'arraybuffer'}).then((response) => {
							var newBlob = new Blob([response.data], {type:"application/pdf"})
							FileSaver.saveAs(newBlob, "CX2-client-experience-drives-customer-experience.pdf");
						})
				}

				setTimeout(function(){
					_this.resetForm(scope);

				}, 300);

				setTimeout(function(){
					_this.contactForm.formSubmitted=false;
				}, 5000);

			},
			openJourney() {
				var elem = document.getElementById("your-journey");
				elem.classList.add("opened");
				elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;

				setTimeout(function(){
					if (window.screen.width <= 768) {
						document.getElementById("your-journey").scrollIntoView({block: "start", behavior: "smooth"});
					}
					else {
						document.getElementById("your-journey").scrollIntoView({block: "end", behavior: "smooth"});
					}
					window.onresize = function(event) {
						elem.maxHeight = elem.getElementsByClassName('inner')[0].offsetHeight + 100;
					};
				},300);
	    },
	    markRecaptchaAsVerifiedJourney(response) {
	      this.journeyForm.pleaseTickRecaptchaMessage = '';
	      this.journeyForm.recaptchaVerified = true;
	    },
			markRecaptchaAsVerifiedContact(response) {
			 this.contactForm.pleaseTickRecaptchaMessage = '';
			 this.contactForm.recaptchaVerified = true;
		 },
		 resetForm(scope) {
			 this.$validator.pause();

			 if(scope=='contactForm'){
					 this.contactForm.recaptchaVerified = false;
					 this.contactForm.pleaseTickRecaptchaMessage = '';
					 this.contactForm.first_name = '';
					 this.contactForm.last_name = '';
					 this.contactForm.company = '';
					 this.contactForm.email = '';
					 this.contactForm.description = '';
					 this.contactForm.check_1 = '';
					 this.contactForm.check_2 = '';
					 this.contactForm.check_3 = '';
					 this.contactForm.checkBoxSelected = true;
			}

			if(scope=='journeyForm'){
					this.journeyForm.recaptchaVerified = false;
					this.journeyForm.pleaseTickRecaptchaMessage = '';
					this.contactForm.first_name = '';
					this.contactForm.last_name = '';
					this.contactForm.company = '';
					this.contactForm.email = '';
		 }

			this.$validator.errors.clear();
			this.$validator.reset();
			document.getElementById(scope).reset();
		},
	    validateForm(scope) {
				this.$validator.resume();
				const dict = {
					custom: {
            email: {
              required: 'This is a required field.',
              email: 'Please enter a validate email address'
            },
            last_name: {
              required: 'This is a required field.',
            },
            first_name: {
              required: 'This is a required field.',
            },
            company: {
              required: 'This is a required field.',
            },
            description: {
              required: 'This is a required field.',
            }
          }
				};
				this.$validator.localize('en', dict);
				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						//Check scope
						var formData = new FormData(document.getElementById(scope));
						var myForm;
						if(scope=='contactForm'){
							if(formData.get('check_1')!==null || formData.get('check_2')!==null || formData.get('check_3')!==null){
								this.contactForm.checkBoxSelected = true
							}
							else {
								this.contactForm.checkBoxSelected = false
								return true;
							}
						}
						if(scope=='contactForm'){
							myForm = this.contactForm;
							if (!this.contactForm.recaptchaVerified) {
				        this.contactForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
				        return true; // prevent form from submitting
				      }
						}

						if(scope=='journeyForm'){
							myForm = this.journeyForm;
							if (!this.journeyForm.recaptchaVerified) {
				        this.journeyForm.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
				        return true; // prevent form from submitting
				      }
						}

						if(scope=='journeyForm'){
							this.webToLead({
	              //Debug mode
	              //debug:1,
	              //debugEmail:'psapir@devsutd.com',
	              oid         : myForm.oid,
	              first_name  : myForm.first_name,
	              last_name   : myForm.last_name,
	              email       : myForm.email,
	              company     : myForm.company,
	              lead_source : myForm.lead_source,
	              Campaign_ID : myForm.campaign,
	            }, scope);
						}

						if(scope=='contactForm'){
							console.log(myForm);
							this.webToLead({
	              //Debug mode
	              // debug:1,
	              // debugEmail:'psapir@devsutd.com',

	              oid         : myForm.oid,
	              first_name  : myForm.first_name,
	              last_name   : myForm.last_name,
	              email       : myForm.email,
	              company     : myForm.company,
	              lead_source : myForm.lead_source,
	              Campaign_ID : myForm.campaign,
								description : myForm.description,
								'00N3u00000P7NXH' : (myForm.check_1 ? '1' : myForm.check_1),
								'00N3u00000P7NXM' : (myForm.check_2 ? '1' : myForm.check_2),
								'00N3u00000P7NXR' : (myForm.check_3 ? '1' : myForm.check_3)
	            }, scope);
						}

						return false;

					}
				});
	    },
		},
		components:{
			'hero':hero,
			VueRecaptcha
		},
		mixins:[seoModule]
	}
</script>



// WEBPACK FOOTER //
// CX2.vue?7d1bc9d9